import "./Landingpage.css";
interface Props {
  image: string;
}
const ImageCard = (props: Props) => {
  return <img className="img_card" src={props.image} alt="gallery_image" />;
};

export default ImageCard;
